export default __webpack_public_path__ + "static/media/pr.16484ae5.svg";